module.exports = __webpack_public_path__ + "static/media/DIRAD.ef399365.png";